import { Button } from '@/common/ui/Form/Button'
import { Fieldset } from '@/common/ui/Form/Fieldset'
import { Input } from '@/common/ui/Form/Input'
import { useOrgForm } from '../model/orgForm'
import { cn } from '@/common/lib/cn/cn'
import { useMe } from '@/common/entities/me/model/me'
import { OrgLogoUploadBlock } from './OrgLogoUploadBlock'

export const OrgForm = ({ className }: { className?: string }) => {
    const { form, currentOrg, currentOrgLoading, handleSubmit, onSubmit, register, isPending } = useOrgForm()
    const { me } = useMe()

    const formClasses = cn(
        {
            skelet: currentOrgLoading,
        },
        className
    )
    if (!currentOrg) {
        return (
            <div>
                <div className='grid-col-1'>У вас нет организаций</div>
            </div>
        )
    }
    return (
        <>
            <div className='grid-cols-2'>
                <h3 className='text-lg font-medium mb-2'>Данные организации</h3>
            </div>
            <form method='post' className={formClasses} onSubmit={handleSubmit(onSubmit)}>
                <div className='grid-col-1'>
                    <Fieldset
                        label='Название организации'
                        errorText={form.formState.errors.name?.message}
                        disabled={currentOrg?.owner_id !== me?.id}
                        helpText='Только владелец организации может изменить название'
                    >
                        <Input
                            className='w-full'
                            size='lg'
                            placeholder='Введите название организации'
                            type='text'
                            disabled={currentOrg?.owner_id !== me?.id}
                            {...register('name', {
                                required: 'Название организации обязательно',
                            })}
                        />
                    </Fieldset>
                </div>
                <OrgLogoUploadBlock
                    orgId={currentOrg.id}
                    orgName={currentOrg.name}
                    logoUrl={currentOrg.logo_url}
                    disabled={currentOrg.owner_id !== me?.id}
                    orgLoading={currentOrgLoading}
                />
                {/*
                <div className='grid-col-1'>
                    <Fieldset label='ИНН'>
                        <Input
                            className='w-full'
                            name='inn'
                            size='lg'
                            placeholder='Введите ИНН'
                            value='1234567890'
                            type='text'
                            disabled
                        />
                    </Fieldset>
                </div>
                <div className='grid-col-2'>
                    <Fieldset label='Юридическое наименование'>
                        <Input
                            className='w-full'
                            name='legal_name'
                            size='lg'
                            placeholder='Введите юридическое наименование'
                            type='text'
                            disabled
                        />
                    </Fieldset>
                </div>
                */}
                <div className='grid-col-1 actions'>
                    <Button
                        color='accent'
                        size='lg'
                        type='submit'
                        disabled={currentOrgLoading || isPending || currentOrg?.owner_id !== me?.id}
                        loading={isPending}
                    >
                        Сохранить
                    </Button>
                </div>
            </form>
        </>
    )
}
